// extracted by mini-css-extract-plugin
module.exports = {"content":"CardArticle_content__C0x5E","image":"CardArticle_image__RErI5"};